import { galleryTypes } from "../actions/types";

const initialState = {
  searchTerm: "",
  categoria: "",
  rubro: "",
  subRubro: "",
  promocion: "",
};

export const galleryReducer = (state = initialState, action) => {
  switch (action.type) {
    case galleryTypes.SET_SEARCH_TERM:
      return {
        ...state,
        ...action.payload,
      };
    case galleryTypes.SET_CATEGORIA:
      return {
        ...state,
        ...action.payload,
      };
    case galleryTypes.SET_RUBRO:
      return {
        ...state,
        ...action.payload,
      };
    case galleryTypes.SET_SUBRUBRO:
      return {
        ...state,
        ...action.payload,
      };
    case galleryTypes.SET_PROMOCION:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
